import { useNotifications } from '@sequencehq/core-components'
import { getQuoteFromTemplateUrl } from 'common/utils/urls'

interface UseCopyTemplateLinkProps {
  quoteTemplateId: string
}

interface UseCopyTemplateLinkResult {
  copyTemplateLink: () => Promise<boolean>
}

export function useCopyTemplateLink(
  props: UseCopyTemplateLinkProps
): UseCopyTemplateLinkResult {
  const { displayNotification } = useNotifications()

  return {
    copyTemplateLink: async () => {
      const templateUrl = getQuoteFromTemplateUrl(props.quoteTemplateId)
      await navigator.clipboard.writeText(templateUrl)
      displayNotification('Template link copied to clipboard', {
        type: 'success'
      })
      return true
    }
  }
}
